import { useVuexGetters, useVuexState } from '@scfe-common/micro-frontend-utils';
import { getStationAbilityId } from '@spx-portal/shared-context';

import { IS_TH } from '@/utils/multiRegion';

export default function useStationParams() {
  const stationGrayConfig = useVuexGetters('workforceGlobalDataOps/stationGrayConfig') || {};
  const stationTypes = useVuexState('enums.systemEnums.station_types') || {};

  const wfmAuditAbilityId = getStationAbilityId('WorkforceManagement');
  const getStationDropdownParams = (format?: string | undefined) => {
    const stationTypeList = [
      stationTypes['First Mile HUB'],
      stationTypes.DC,
      stationTypes.HUB,
      stationTypes['All Mile HUB'],
      stationTypes['VIP PUP'],
      stationTypes['FBS Warehouse'],
      stationTypes['Operator Hub'],
      stationTypes['Mobile Hub'],
      stationTypes['Express Hub'],
    ];

    if (stationGrayConfig.is_use_station_common_site && wfmAuditAbilityId) {
      return {
        ability_list: [wfmAuditAbilityId].join(','),
      };
    }

    const needArr = format === 'array';
    return {
      station_type_list: needArr ? stationTypeList : stationTypeList.join(','),
    };
  };

  return {
    getStationDropdownParams,
  };
};
